import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { MapPin, Plus } from "lucide-react";

export default function EmptyTripsState({ onNew }) {
  return (
    <Card className="rounded-2xl p-12 border-border border-dashed text-center" data-testid="empty-trips">
      <div className="mx-auto w-14 h-14 rounded-2xl bg-muted grid place-items-center">
        <MapPin className="w-6 h-6 text-primary" />
      </div>
      <h3 className="font-display text-2xl mt-4">No trips yet</h3>
      <p className="text-stone-500 mt-1">Create your first trip to start storing travelers, tickets and receipts.</p>
      <Button onClick={onNew} className="mt-6 rounded-full bg-primary text-primary-foreground" data-testid="empty-new-trip-btn">
        <Plus className="w-4 h-4 mr-2" /> New trip
      </Button>
    </Card>
  );
}
